<template>
  <div class="w-full xl:px-10 px-5 pb-10">
    <div class="w-full border border-gray-300 lg:p-10 p-8 rounded-md">
      <h3 class="text-[#656d76] mb-2 text-sm font-bold">Non-Discrimination Statement</h3>
      <p class="text-[#656d76] text-sm leading-6 mb-3">In accordance with federal civil rights law and U.S. Department of Agriculture (USDA) civil rights regulations and policies, this institution is prohibited from discriminating on the basis of race, color, national origin, sex (including gender identity and sexual orientation), disability, age, or reprisal or retaliation for prior civil rights activity.</p>
      <p class="text-[#656d76] text-sm leading-6 mb-3">Program information may be made available in languages other than English. Persons with disabilities who require alternative means of communication to obtain program information (e.g., Braille, large print, audiotape, American Sign Language), should contact the responsible state or local agency that administers the program or USDA’s TARGET Center at (202) 720-2600 (voice and TTY) or contact USDA through the Federal Relay Service at (800) 877-8339.</p>
      <p class="text-[#656d76] text-sm leading-6 mb-3">To file a program discrimination complaint, a Complainant should complete a Form AD-3027, USDA Program Discrimination Complaint Form which can be obtained online at: <a href="https://www.usda.gov/sites/default/files/documents/ad-3027.pdf" target="_blank" rel="noopener noreferrer" class="
        text-[#0092D0] underline hover:no-underline break-all">https://www.usda.gov/sites/default/files/documents/ad-3027.pdf</a>, from any USDA office, by calling (866) 632-9992, or by writing a letter addressed to USDA. The letter must contain the complainant’s name, address, telephone number, and a written description of the alleged discriminatory action in sufficient detail to inform the Assistant Secretary for Civil Rights (ASCR) about the nature and date of an alleged civil rights violation. The completed AD-3027 form or letter must be submitted to USDA by:</p>
      <ol class="mb-5 ml-7 text-sm text-[#656d76] space-y-2 list-decimal">
        <li><span class="font-bold">mail:</span><br>
        U.S. Department of Agriculture<br>
        Office of the Assistant Secretary for Civil Rights<br>
        1400 Independence Avenue, SW<br>
        Washington, D.C. 20250-9410; or</li>
        <li><span class="font-bold">fax:</span><br>
        (833) 256-1665 or (202) 690-7442; or</li>
        <li><span class="font-bold">email:</span><br>
        <a href="mailto:program.intake@usda.gov" class="
        text-[#0092D0] underline hover:no-underline">Program.Intake@usda.gov</a></li>
      </ol>
      <p class="text-[#656d76] text-sm leading-6 mb-3">This institution is an equal opportunity provider.</p>
      <p class="text-[#656d76] text-sm leading-6">Menu is subject to change. A variety of milk is offered each day.</p>
    </div>
  </div>
  <footer class="bg-blue-nutri flex items-center justify-between flex-wrap">
    <div class="w-full relative py-5 px-6 text-center text-white">
      © {{currentYear()}} Simply Good Food <br> 
      
      <a href="/login-page">Login</a>
    </div> 
  </footer>
</template>

<script>
export default {

  data: function () {
    return {
    }
  },
  methods: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
}

</script>
